import { Language, List, ListAlt, Lock, PrivacyTip, TextSnippet } from '@mui/icons-material';
import type { RefAttributes } from 'react';
import type { useForm } from 'react-hook-form';
import { _ } from '/@/locale';
import type { ProfileV2FormData } from '..';
import LanguageAndCountryEditTab from './language-and-country-edit';
import PasswordEditTab from './password-edit';
import PrivacyTab from './privacy';
import ProfileEditTab from './profile-edit';
import TermsAndConditionsTab from './terms-and-conditions';
import UnitsEditTab from './units-edit';

export type TabKey = 'profileEdit' | 'passwordEdit' | 'languageEdit' | 'unitsEdit' | 'privacy' | 'terms';
export const useTabs = (): Record<
    TabKey,
    React.ComponentType<{ form: ReturnType<typeof useForm<ProfileV2FormData>> } & RefAttributes<unknown>>
> => {
    return {
        profileEdit: ProfileEditTab,
        passwordEdit: PasswordEditTab,
        languageEdit: LanguageAndCountryEditTab,
        unitsEdit: UnitsEditTab,
        privacy: PrivacyTab,
        terms: TermsAndConditionsTab,
    };
};

export const useSidebarTabs = (): {
    title: string;
    tabs: Partial<Record<TabKey, { label: string; icon: React.ReactNode; onClick: () => void }>>;
}[] => [
    {
        title: _('Perfil'),
        tabs: {
            profileEdit: {
                label: _('Información personal'),
                icon: <ListAlt color='primary' />,
                onClick: () => {},
            },
        },
    },
    {
        title: _('Seguridad'),
        tabs: {
            passwordEdit: {
                label: _('Cambiar contraseña'),
                icon: <Lock color='primary' />,
                onClick: () => {},
            },
        },
    },
    {
        title: _('Preferencias'),
        tabs: {
            languageEdit: {
                label: _('Idioma y país'),
                icon: <Language color='primary' />,
                onClick: () => {},
            },
            unitsEdit: {
                label: _('Unidades de medición'),
                icon: <List color='primary' />,
                onClick: () => {},
            },
        },
    },
    {
        title: _('Legales'),
        tabs: {
            privacy: {
                label: _('Políticas de privacidad'),
                icon: <PrivacyTip color='primary' />,
                onClick: () => {},
            },
            terms: {
                label: _('Términos y condiciones'),
                icon: <TextSnippet color='primary' />,
                onClick: () => {},
            },
        },
    } as const,
];
